import React from 'react';
import { connect } from 'react-redux';
import MasterComponent from '../../components/Forms';
import { MasterConfigs } from '../../interfaces/entity';
import { useDispatch } from 'react-redux';
import { getData } from '../../actions/apiCall';
import { Button, FormInstance } from 'antd';
import { postData } from '../../actions/developer';

const EmailKeysMaps = () => {
  const dispatch = useDispatch();
  const [form, setForm] = React.useState<FormInstance>(null);

  function extractKeysFromTemplate(template: string): string[] {
    const regex = /{{(.*?)}}/g;
    let match;
    const keys: string[] = [];

    while ((match = regex.exec(template)) !== null) {
      keys.push(`{{${match[1].trim()}}}`);
    }

    return Array.from(new Set(keys)); // Ensures unique keys
  }

  const getTemplate = async (id) => {
    const data = await dispatch(getData(`/cms/emailTemplates/${id}`));
    if (data.code === 200) {
      const keys = extractKeysFromTemplate(data.data.description).concat(extractKeysFromTemplate(data.data.subject));
      const exsitingForm = form.getFieldsValue();
      exsitingForm.keys = exsitingForm.keys || [];
      const existingKeysSet = new Set(exsitingForm.keys.map((key) => key.keyString));
      const updatedKeys = keys.map((key) => {
        if (existingKeysSet.has(key)) {
          return exsitingForm.keys.find((item) => item.keyString === key);
        }
        return { keyString: key };
      });

      form.setFieldsValue({
        ...exsitingForm, keys: updatedKeys
      });
    }
  }

  const onSubmitQuery = async (query) => {
    try {
      const resData = await dispatch(postData('/cms/emailKeysMap/execute/query', { mongoQuery: query, collectionName: form.getFieldValue('collectionName') }));
      console.log("Mongo Query Result", resData);
    } catch (error) {
      console.log(error);
    }
  }

  const emailKeyMapConfig: MasterConfigs = {
    api: () => '/cms/emailKeysMap',
    title: 'Key Maps',
    isActionTab: true,
    modalTitle: (action) => `${action} Keys`,
    handleValuesChange: (values) => {
      if (values.emailTemplate) {
        getTemplate(values.emailTemplate);
      }

    },
    getColumns: () => {
      return [
        {
          title: 'Email Template',
          dataIndex: 'emailTemplate',
          key: 'emailTemplate',
          isSearch: true,
          render: (value) => value.name,
        },
        {
          title: 'Collection Name',
          dataIndex: 'collectionName',
          key: 'collectionName',
          isSearch: true,
        },
        {
          title: 'keys',
          dataIndex: 'keys',
          key: 'keys',
          isSearch: true,
          render: (text) => text.length,
        },
      ];
    },
    getFormColumns: () => {
      return [
        {
          label: 'Email Template',
          name: 'emailTemplate',
          rules: [{ required: true, message: 'Field is required' }],
          type: 'select',
          selectProps: { allowClear: true },
          isCombo: true,
        },
        {
          label: 'Collection Name',
          name: 'collectionName',
          rules: [{ required: true, message: 'Field is required' }],
          type: 'select',
          isCombo: true,
          selectProps: { allowClear: true },
          span: 6,
        },
        {
          label: 'Mongo Query',
          name: 'mongoQuery',
          type: 'textarea',
          span: 18,
          inputTextAreaProps: { rows: 4, defaultValue: '{conditions: {}, populate: []}' },
        },
        {
          type: 'custom',
          formItem: () => <Button type="primary" onClick={() => onSubmitQuery(form.getFieldValue('mongoQuery'))}>Execute</Button>,
          span: 6
        },
        {
          label: 'Key Maps',
          name: 'keys',
          type: 'form',
          span: 24,
          form: [
            {
              label: 'Key String',
              name: 'keyString',
              type: 'text',
              rules: [{ required: true, message: 'Field is required' }],
              span: 6,
            },
            {
              label: 'Formated Value',
              name: 'value',
              rules: [{ required: true, message: 'Field is required' }],
              type: 'textarea',
              span: 12,
            },
          ],
        },
      ];
    },
    combo: [
      {
        name: 'emailTemplate',
        api: '/cms/emailTemplates',
        idKey: '_id',
        render: (text) => text.name
      },
      {
        name: 'collectionName',
        api: '/cms/emailKeysMap/all/table/names',
        idKey: 'name',
        render: (text) => text.name
      },
    ],
    getData: () => ({}),
    actions: [
      { name: 'Add Template', actionType: "Add" },
      { name: 'Return', actionType: "Back" },
    ],
  };



  return <MasterComponent config={emailKeyMapConfig} form={setForm} />
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.app.isAuthenticated,
  user: state.app.user,
});

export default connect(mapStateToProps)(EmailKeysMaps);

